import { useEffect, useState } from 'react';
import classNames from 'classnames';

/**
 * دایره نمایش تصویر entity (کاربر/سازمان) با fallback حرف اول
 */
export default function EntityCircleBadge({
  imageUrl,
  label,
  accentColor = '#94a3b8',
  size = 36,
  className,
  roundedClassName = 'rounded-lg',
  textClassName = 'text-sm font-bold text-white',
  objectFit = 'cover',
}) {
  const [failed, setFailed] = useState(false);
  const initial = (label || '؟').trim().charAt(0) || '؟';
  const contain = objectFit === 'contain';
  const pad = contain ? Math.max(3, Math.round(size * 0.14)) : 0;
  const boxStyle = {
    width: size,
    height: size,
    minWidth: size,
    minHeight: size,
    maxWidth: size,
    maxHeight: size,
    padding: pad,
  };
  const src = typeof imageUrl === 'string' && imageUrl.trim() ? imageUrl.trim() : '';

  useEffect(() => {
    setFailed(false);
  }, [src]);

  if (src && !failed) {
    return (
      <span
        className={classNames(
          'box-border inline-flex shrink-0 items-center justify-center overflow-hidden border border-slate-100 bg-white dark:border-white/10',
          roundedClassName,
          className,
        )}
        style={boxStyle}
      >
        <img
          src={src}
          alt={label || ''}
          className={classNames(
            'block min-h-0 min-w-0',
            contain
              ? 'h-auto max-h-full w-auto max-w-full object-contain'
              : 'h-full w-full object-cover',
          )}
          loading="lazy"
          onError={() => setFailed(true)}
        />
      </span>
    );
  }

  return (
    <span
      className={classNames(
        'inline-flex shrink-0 items-center justify-center shadow-soft',
        roundedClassName,
        textClassName,
        className,
      )}
      style={{
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        background: accentColor,
      }}
    >
      {initial}
    </span>
  );
}
